import { Box, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import "../../../styles/global.scss"
import Layout from "../Layout"

const BG_URL = "https://pgm-media.fteledition.fr/Uploads/ed79cc2d-4282-4a2c-9bbc-38cd9ce06b1c/Plan_de_travail_1fond_new_full.png"
const LOGO_URL = "https://pgm-media.fteledition.fr/Uploads/78a72ac3-4f51-4269-ae23-093bf3516914/Fichier_1Mi_blanc.png"
const CENTER_GIF_URL = "https://pgm-media.fteledition.fr/Uploads/2e709b69-507a-46df-9b88-9df01506e886/Soccer_empty_state_1_.gif"

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: "100vh",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: theme.spacing(4, 2),
    color: "#fff",
    overflow: "hidden",
  },
  logo: {
    width: 320,
    maxWidth: "72vw",
    marginBottom: theme.spacing(5),
  },
  centerGif: {
    width: 170,
    maxWidth: "42vw",
    marginBottom: theme.spacing(5),
  },
  title: {
    fontFamily: "Montserrat-Bold",
    fontSize: "2rem",
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.35rem",
    },
  },
  subtitle: {
    maxWidth: 900,
    color: "#d7d7d7",
    fontSize: "1rem",
    lineHeight: 1.6,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.92rem",
      maxWidth: 340,
    },
  },
  decor: {
    position: "absolute",
    fontSize: 92,
    lineHeight: 1,
    userSelect: "none",
    [theme.breakpoints.down("sm")]: {
      fontSize: 62,
    },
  },
  ball: {
    left: theme.spacing(4),
    bottom: theme.spacing(4),
  },
  trophy: {
    right: theme.spacing(12),
    top: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
      right: theme.spacing(2),
      top: theme.spacing(3),
    },
  },
  rugby: {
    right: theme.spacing(4),
    bottom: theme.spacing(4),
  },
}))

function FinishPage() {
  const classes = useStyles()

  document.documentElement.style.setProperty("--bg-image", `url("${BG_URL}")`)

  return (
    <Layout title={"Merci !"}>
      <Box className={classes.page}>
        <img className={classes.logo} src={LOGO_URL} alt='Pronostic Games' />
        <img className={classes.centerGif} src={CENTER_GIF_URL} alt='Chargement de la création de plateforme' />

        <Typography className={classes.title}>Merci pour votre demande, c&apos;est en cours de livraison !</Typography>
        <Typography className={classes.subtitle}>
          Votre plateforme Pronostic Games est en cours de création. Vous recevrez un email sous peu avec les accès à votre plateforme. Un membre de
          l&apos;équipe prendra contact avec vous pour comprendre au mieux vos besoins.
        </Typography>
      </Box>
    </Layout>
  )
}

export default FinishPage
